export enum DelayTrigger {
  USER = 'user',
  PAUSE_MODAL = 'pauseModal',
}

export enum AdvancePurchaseTrigger {
  USER = 'user',
}
